import { PageHandler } from '@edreamsodigeo/frontend-core';
export const pageHandler = PageHandler();